<div *ngFor="let question of questions">
  <diy-data #data [show]="true" [playerWidth]="playerWidth" [preview]="preview" [question]="question"></diy-data>
</div>
